import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  Component,
  OnInit,
  ViewChild,
  inject,
  DestroyRef,
} from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ToolbarComponent } from '@shared/components/toolbar/toolbar.component';

import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { SearchFieldComponent } from '@shared/components/search-field/search-field.component';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ButtonComponent } from '@shared/components/button/button.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TitleComponent } from '@shared/components/title/title.component';
import { MatCardModule } from '@angular/material/card';
import { ActivatedRoute } from '@angular/router';
import { ParkingService } from '@admin/services';
import { Cookies } from 'typescript-cookie';

@Component({
  templateUrl: './view-parking-page.component.html',
  styles: [],
  standalone: true,
  imports: [
    MatCardModule,
    TitleComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    ButtonComponent,
    MatDatepickerModule,
    MatButtonModule,
    SearchFieldComponent,
    MatTableModule,
    MatSortModule,
    MatMenuModule,
    MatIconModule,
    MatPaginatorModule,
    MatNativeDateModule,
    ToolbarComponent,
  ],
})
export class ViewParkingPageComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  private dialog = inject(MatDialog);
  private parkingService = inject(ParkingService);
  private formBuilder = inject(FormBuilder);
  private destroyRef = inject(DestroyRef);
  private _activatedRoute = inject(ActivatedRoute);
  public pageSubTitle: string = '';
  formUser!: FormGroup;
  formDate!: FormGroup;
  cookieBussinesId = Cookies.get('bussinesId');

  displayedColumns: string[] = [
    'date',
    'user',
    'name',
    'lastname',
    'since',
    'until',
    'place',
    'level',
    'building',
    // 'options',
  ];
  dataSource: MatTableDataSource<string>;
  fielInput!: string;
  constructor() {
    this.dataSource = new MatTableDataSource();
  }
  ngOnInit() {
    this.chargueParking();
  }

  chargueParking() {
    this.parkingService
      .getWithParking(this.cookieBussinesId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response: any) => {
        if (response.code === 10000) {
          this.dataSource = new MatTableDataSource(response.reply);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          //Colocar el texto en Spanish
          if (this.paginator) {
            this.paginator._intl.itemsPerPageLabel = 'Registros por página';
            this.paginator._intl.nextPageLabel = 'Página siguiente ';
            this.paginator._intl.previousPageLabel = 'Página anterior';
            this.paginator._intl.firstPageLabel = 'Primera página';
            this.paginator._intl.lastPageLabel = 'Última página';
            // Configuración del texto de la última página
            this.paginator._intl.getRangeLabel = (
              page: number,
              pageSize: number,
              length: number
            ) => {
              if (length === 0 || pageSize === 0) {
                return `0 de ${length}`;
              }
              length = Math.max(length, 0);
              const startIndex = page * pageSize;
              const endIndex =
                startIndex < length
                  ? Math.min(startIndex + pageSize, length)
                  : startIndex + pageSize;
              return `${startIndex + 1} - ${endIndex} de ${length}`;
            };
          }
        }
      });
  }
}
